<template>
  <el-drawer
    :title="drawerDatas.isRowVirtual == false ? drawerDatas.reName : ''"
    v-model="newDrawer"
    :direction="'btt'"
    class="drawerDom"
    append-to-body
    :show-close="!isFrontEnd && !$route.query.search"
    :before-close="handleClose"
    :withHeader="false"
    size="100%"
  >
    <!-- backgroundColor: drawerDatas.type === 'indicatorsBread' && drawerDatas.chartType !== 'indicators' && theme && theme.backgroundColor ? theme.backgroundColor : '' -->

    <div :style="{ height: '100%' }">
      <div class="drawerDom-header" :style="{color: drawerDatas.type === 'indicatorsBread' && drawerDatas.chartType !== 'indicators' && theme && theme.titleColor ? theme.titleColor : ''}">
        <select-box v-if="!drawerDatas.nameShow"
                  class="select-box"
                  :data="drawerDatas"
                  :index="drawerDatasIndex"
                  :width="'100%'"
                  :draggable="false"
                  :resizable="false"
                  :isFrontEnd="false"
                  @handle="handle"
                />

        <!-- <div class="header-text"></div> -->
        <!-- <div class="header-text">{{drawerDatas.isRowVirtual == false ? drawerDatas.reName : ''}}</div> -->
        <i class="iconfont icon-shanchu3" @click="$emit('update:drawer', false)" />
        <!--        <i class="iconfont icon-shanchu3" @click="drawer = false" />-->
      </div>
      <!-- 骨架屏 -->
      <skeleton-view
        v-if="
        drawerDatas.skeletonLoading === true &&
        drawerDatas.appId &&
        drawerDatas.appId != ''
      "
        :h="85"
        style="padding: 0 20px"
      />

      <!-- 内容 -->
      <!-- 选择框 -->
      <!-- <select-box
        class="select-box"
        :theme="theme"
        :data="drawerDatas"
        :index="drawerDatasIndex"
        :draggable="draggable"
        :resizable="resizable"
        :isFrontEnd="isFrontEnd"
        :drawer="drawer"
        @handle="handle"
      >
      </select-box> -->
      <!-- 明细表 -->
      <template
        v-if="
        (drawerDatas.type === 'detailed' &&
          drawerDatas.skeletonLoading === false) ||
        (!drawerDatas.skeletonLoading && drawerDatas.type === 'detailed')
      "
      >
        <div class="grid-table">
          <!-- 表格内容 -->
          <table-detail :tableDetailData="drawerDatas"
                        @relevanceFun="changeRelevanceFun"
                        @singleRelevance="singleRelevance" />
        </div>
        <drageGridNav
          :subScript="drawerDatasIndex"
          :pageTotal="drawerDatas.pageTotal"
          :article="drawerDatas.article"
          :curpage="drawerDatas.curpage"
          :disabled="disabled"
          @pageChange="pageChange"
        />
      </template>
      <!-- 汇总表 -->
      <template
        v-if="
        (drawerDatas.type === 'summary' &&
          drawerDatas.skeletonLoading === false) ||
        (!drawerDatas.skeletonLoading && drawerDatas.type === 'summary')
      "
      >
        <div class="grid-table" style="height: 84.9vh; overflow: auto">
          <sumTable
            v-if="drawerDatas.merge && drawerDatas.merge.length > 0"
            :row="drawerDatas.row"
            :config="drawerDatas"
            :column="drawerDatas.column"
            :summary="drawerDatas.summary"
            :topCount="drawerDatas.topCount"
            :ref="'sumTable_' + drawerDatas.i"
            :isSummary="drawerDatas.isSummary"
            :tableData="drawerDatas.tableData"
            :mergeTable="drawerDatas.tableMerge"
            :merge="drawerDatas.merge"
            :isFrontEnd="isFrontEnd"
            :total="drawerDatas.pageTotal || 0"
            :totalPage="drawerDatas.pages || 0"
            :page="drawerDatas.devCurpage"
            :overflowTable="drawerDatas.overflow"
            @relevanceFun="changeRelevanceFun"
            :selectRow="drawerDatas.selectRow"
            :selectCloum="drawerDatas.selectCloum"
            :selectPage="drawerDatas.selectPage"
            :index="layoutLength + drawerDatasIndex + 1 + ''"
            :id="drawerDatas.i"
          ></sumTable>
        </div>
        <drageGridNav
          :subScript="drawerDatasIndex"
          :pageTotal="drawerDatas.pageTotal || 0"
          :article="drawerDatas.devArticle"
          :curpage="drawerDatas.devCurpage"
          :disabled="disabled"
          @pageChange="sumPageChange"
        />
      </template>
      <!-- 指标/饼图 -->
      <template
        v-if="
        (drawerDatas.type === 'indicatorsBread' &&
          drawerDatas.skeletonLoading === false) ||
        (!drawerDatas.skeletonLoading && drawerDatas.type === 'indicatorsBread')
      "
      >
        <div class="grid-table" style="height: 84.9vh; overflow: auto">
          <!-- 表格内容 -->
          <!-- 指标图表格内容 -->
          <!-- <indicators-details
            :tableData="drawerDatas.tableData"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :reName="drawerDatas.reName"
            :fontSize="drawerDatas.h"
            :total="drawerDatas.totalValue"
            :defaultImg="drawerDatas.icon"
            :color="drawerDatas.color"
            :isRowVirtual="drawerDatas.isRowVirtual"
            :defaultStyleConfig="drawerDatas.styleConfig"
            @relevanceFun="changeRelevanceFun"
            :id="drawerDatas.i"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            :page="drawerDatas.devCurpage"
            :selectPage="drawerDatas.selectPage"
            ref="indicatorsRefs"
            v-if="drawerDatas.chartType === 'indicators'"
            :drawer="true"
          /> -->
          <!-- 饼图表格内容 -->
          <!-- <bread-details
            v-else-if="drawerDatas.chartType === 'bread'"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :isFrontEnd="isFrontEnd"
            @relevanceFun="changeRelevanceFun"
            :selectIndex="drawerDatas.selectIndex"
            :id="drawerDatas.i"
            :changeSize="drawerDatas.w + drawerDatas.h"
          /> -->
          <!-- 面积图 -->
          <!-- <proportion-details
            ref="proportionRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'proportion'"
          /> -->
          <!-- 柱状图 -->
          <!-- <columnar-details
            ref="columnarRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'columnar'"
          /> -->
          <!-- 环形图 -->
          <!-- <annular-details
            ref="annularRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'annular'"
          /> -->
          <!-- 折线图 -->
          <!-- <broken-line-details
            ref="brokenLineRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'brokenLine'"
          /> -->
          <!-- 条形图 -->
          <!-- <bar-type-details
            ref="barTypeRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'barType'"
          /> -->
          <!-- 条形图 -->
          <!-- <bar-type-details
            ref="barTypeRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'barType'"
          /> -->
          <!-- 柱状堆积图 -->
          <!-- <columnarStacking
            ref="columnarStackingRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'columnarStacking'"
          /> -->
          <!-- 散点图 -->
          <!-- <scatter
            ref="scatterRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'scatter'"
          /> -->
          <!-- 雷达图 -->
          <!-- <radar
            ref="radarRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'radar'"
          /> -->
          <!-- 时间轴 -->
          <!-- <timeline
            ref="timelineRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'timeline'"
          /> -->
          <!-- K线图 -->
          <!-- <candlestick
            ref="candlestickRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'candlestick'"
          /> -->
          <!-- 热力图 -->
          <!-- <heatmap
            ref="heatmapRefs"
            :theme="theme"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :summary="drawerDatas.summary"
            :column="drawerDatas.column"
            :isFrontEnd="isFrontEnd"
            :selectIndex="drawerDatas.selectIndex"
            @relevanceFun="changeRelevanceFun"
            v-else-if="drawerDatas.chartType === 'heatmap'"
          /> -->
          <!-- 地图 -->
          <!-- <mapContainer
            ref="mapRefs"
            v-else-if="drawerDatas.chartType === 'gdMap'"
            v-model:tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :column="drawerDatas.column"
            :summary="drawerDatas.summary"
            :mapConfig="drawerDatas.gdMapConfig"
          /> -->
          <!-- 矩形树图 -->
          <!-- <treemap
            v-else-if="drawerDatas.chartType === 'treemap'"
            :theme="theme"
            :viewShow="drawerDatas.viewShow"
            ref="treemapRefs"
            :tableData="drawerDatas.tableData"
            :id="drawerDatas.i"
            :row="drawerDatas.row"
            :column="drawerDatas.column"
            :summary="drawerDatas.summary"
            :isFrontEnd="isFrontEnd"
            @relevanceFun="changeRelevanceFun"
            :changeSize="drawerDatas.w + drawerDatas.h"
            :user="drawerDatas.user"
            :config="drawerDatas.treemapConfig"
          /> -->
        </div>
        <drageGridNav
          v-if="
          (!drawerDatas.skeletonLoading &&
            drawerDatas.chartType === 'indicators') ||
          (drawerDatas.skeletonLoading === false &&
            drawerDatas.chartType === 'indicators') ||
          (drawerDatas.appId == '' && drawerDatas.chartType === 'indicators')
        "
          :subScript="drawerDatasIndex"
          :pageTotal="
          drawerDatas.pageTotal
            ? drawerDatas.pageTotal
            : drawerDatas.tableData
            ? drawerDatas.tableData.length
            : 0
        "
          :article="drawerDatas.devArticle"
          :curpage="drawerDatas.devCurpage"
          :disabled="disabled"
          @pageChange="indicatorsChange"
        />
      </template>
    </div>
  </el-drawer>
</template>

<script>
import skeletonView from '@/components/common/skeletonDrawing.vue';//- 仪表盘内容骨架屏加载组件
import selectBox from '../selectBox.vue';//- 操作组件
import tableDetail from '@/components/clientSide/instrument/common/detailed/tableDetail.vue';//- 仪表盘明细表格骨架
import drageGridNav from "../drageGridNav.vue";//- 分页控件骨架
import sumTable from '@/components/clientSide/instrument/common/summaryModel/sumTable.vue'//- 汇总表显示组件骨架
// import indicatorsDetails from '@/components/admins/instrument/common/indicatorsBread/indicatorsDetails.vue'//- 指标图图表骨架
// import breadDetails from '@/components/admins/instrument/common/indicatorsBread/breadDetails.vue'//- 饼图图表骨架
// import proportionDetails from '@/components/admins/instrument/common/indicatorsBread/proportionDetails.vue'//- 面积图表
// import columnarDetails from '@/components/admins/instrument/common/indicatorsBread/columnarDetails.vue'//- 柱状图表
// import annularDetails from '@/components/admins/instrument/common/indicatorsBread/annularDetails.vue'//- 环形图表
// import brokenLineDetails from '@/components/admins/instrument/common/indicatorsBread/brokenLineDetails.vue'//- 折线图表
// import barTypeDetails from '@/components/admins/instrument/common/indicatorsBread/barTypeDetails.vue'//- 条形图表
// import columnarStacking from '@/components/admins/instrument/common/indicatorsBread/columnarStacking.vue'// 柱状堆积图
// import scatter from '@/components/admins/instrument/common/indicatorsBread/scatter.vue'// 散点图
// import radar from '@/components/admins/instrument/common/indicatorsBread/radar.vue'// 雷达图
// import timeline from '@/components/admins/instrument/common/indicatorsBread/timeline.vue'// 时间轴
// import candlestick from '@/components/admins/instrument/common/indicatorsBread/candlestick.vue'// K线图
// import heatmap from '@/components/admins/instrument/common/indicatorsBread/heatmap.vue'// 热力图
// import mapContainer from '@/components/admins/instrument/common/indicatorsBread/MapContainer.vue'// 地图
// import treemap from '@/components/admins/instrument/common/indicatorsBread/treemap.vue'// 矩形树图
export default {
  name: 'drawerCpn',
  props: {
    //- 是否显示扩大区域
    drawer: {
      type: Boolean,
      default: false,
    },
    //- 扩大区域显示数据
    drawerDatas: {
      type: Object,
      default: () => { return {} },
    },
    //- 扩大区域显示序号
    drawerDatasIndex: {
      type: Number,
      default: 0,
    },
    //- draggable 是否可拖拽
    draggable: {
      type: Boolean,
      default: true
    },
    //- resizable 是否可调整大小
    resizable: {
      type: Boolean,
      default: true
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean
    },
    //- 是否可以编辑
    disabled: {
      type: Boolean,
      default: false
    },
    //- 当前drage模块数量（汇总表单独要的参数）
    layoutLength: {
      type: Number,
      default: 0,
    },
    theme: Object
  },
  data () {
    return {
      newDrawer: false
    }
  },
  components: {
    skeletonView,
    selectBox,
    tableDetail,
    drageGridNav,
    sumTable,
    // indicatorsDetails,
    // breadDetails,
    // proportionDetails,
    // columnarDetails,
    // annularDetails,
    // brokenLineDetails,
    // barTypeDetails,
    // columnarStacking,
    // scatter,
    // radar,
    // timeline,
    // candlestick,
    // heatmap,
    // mapContainer,
    // treemap
  },
  methods: {
    singleRelevance (item) {
      this.$emit('singleRelevance', item)
    },
    //- 跳转：扩大区域关闭
    handleClose () {
      // this.$parent.handleClose()
      this.$emit('update:drawer', false)
    },
    //- 跳转：操作区域操作
    handle (e) {
      if (e.status == 'empty') {
        //- 清空关联表单联动条件值
        //- 取消当前选中显示效果
        let drawerDatas = this.drawerDatas;
        if (drawerDatas.type === "indicatorsBread" && drawerDatas.chartType === "indicators") {
          //- 双行指标图
          drawerDatas.selectIndex = null;

        } else if (drawerDatas.type === "summary") {
          // this.$refs.sumTableRefs.clearSelect();
          drawerDatas.selectRow = null;
          drawerDatas.selectCloum = null;

        }
      }
      this.$parent.handle(e)
    },
    //- 跳转：明细表分页操作
    pageChange (e) {
      // 查询当前下标位置
      const ind = this.$parent.layout.findIndex(it => it.i === this.drawerDatas.i)
      if (ind !== -1) e.index = ind
      this.$parent.pageChange(e)
    },
    //- 跳转：汇总表分页操作
    sumPageChange (e) {
      const ind = this.$parent.layout.findIndex(it => it.i === this.drawerDatas.i)
      if (ind !== -1) e.index = ind
      this.$parent.sumPageChange(e)
    },
    //- 跳转：指标图分页操作
    indicatorsChange (e) {
      console.log("e===>", e);
      // return;
      this.$parent.indicatorsChange(e)
    },
    changeRelevanceFun (val) {
      console.log("drawer点击value", val);
      this.$parent.changeRelevanceFun(val, true)



      console.log("执行扩大区域关联启动")


    },

  },

  computed: {

  },

  watch: {
    drawer: {
      handler (val) {
        if (val) {
          this.newDrawer = val
        }
      },
      immediate: true,
    },
    newDrawer: {
      handler (val) {
        if (!val) {
          this.$emit('update:drawer', false)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.icon-shanchu3 {
  color: #333;
}
.select-box {
  width: calc(100% - 22px);
}
.drawerDom {
  .drawerDom-header {
    height: 50px;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    i {
      cursor: pointer;
    }
  }
  // 扩大样式当屏幕小于1400px时（笔记本大小）
  .grid-table {
    padding: 0 20px;
    height: calc(100vh - 105px);
    .tableDetail {
      height: 96%;
    }
  }

  //- 去除el-drawer的默认点击框
  :deep(.el-drawer__header span) {
    outline: 0;
    &:hover,
    &:active,
    &:focus {
      outline: 0;
    }
  }
  :deep(.el-table) {
    height: 95% !important;
  }

  .grid-nav {
    bottom: 1.5vh;
    width: calc(100% - 36px);
    padding: 0 18px;
    margin-left: 0;
    z-index: 999;
    position: absolute;
  }
}

.grid-table {
  width: calc(100vw - 40px);
  //width: calc(100vh - 105px);
  height: 92%;
  overflow: hidden;
}
</style>
